// extracted by mini-css-extract-plugin
export var box = "SocialMedia-module--box--4ae8b";
export var box_md = "SocialMedia-module--box_md--b105f";
export var box_xmd = "SocialMedia-module--box_xmd--01055";
export var box_flex = "SocialMedia-module--box_flex--e8d3f";
export var box_lg = "SocialMedia-module--box_lg--655f4";
export var box_sm = "SocialMedia-module--box_sm--d9dc3";
export var box_outer = "SocialMedia-module--box_outer--b96c5";
export var box_whiteBg = "SocialMedia-module--box_white-bg--bf42a";
export var box_noMarginBottom = "SocialMedia-module--box_no-margin-bottom--8af79";
export var box_noPadding = "SocialMedia-module--box_no-padding--75bf4";
export var box_outerGray = "SocialMedia-module--box_outer-gray--396f7";
export var box_dark = "SocialMedia-module--box_dark--8b978";
export var box_zIndex = "SocialMedia-module--box_z-index--faec5";
export var box_zIndex6 = "SocialMedia-module--box_z-index-6--5eaf4";
export var box_eventsWithLine = "SocialMedia-module--box_events-with-line--8a98d";
export var box_featuresAo = "SocialMedia-module--box_features-ao--02622";
export var box_verticalPaddings = "SocialMedia-module--box_vertical-paddings--6aee5";
export var clearP = "SocialMedia-module--clearP--aa2d7";
export var clearP_vc = "SocialMedia-module--clearP_vc--a5d25";
export var mainContainer = "SocialMedia-module--mainContainer--a0d54";
export var light = "SocialMedia-module--light--d49ad";
export var title = "SocialMedia-module--title--c13fb";
export var button = "SocialMedia-module--button--b1e72";
export var layout = "SocialMedia-module--layout--1e7b4";
export var instaWrapper = "SocialMedia-module--instaWrapper--756c8";
export var buttonRow = "SocialMedia-module--buttonRow--40510";
export var buttonContent = "SocialMedia-module--buttonContent--b7c5f";
export var icon = "SocialMedia-module--icon--9e886";
export var fadeInAnimation = "SocialMedia-module--fadeInAnimation--db2ab";
export var placeHolderShimmer = "SocialMedia-module--placeHolderShimmer--e2e1c";